import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import LanguageSwitcher from './LanguageSwitcher';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();

  const navItems = [
    { name: t('nav.home'), type: 'scroll', href: '#home' },
    { name: t('nav.team'), type: 'scroll', href: '#team' },
    { name: t('nav.about'), type: 'scroll', href: '#about' },
    { name: t('nav.contact'), type: 'scroll', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black bg-opacity-90 backdrop-blur-sm border-b border-gray-800">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src={`${process.env.PUBLIC_URL}/images/logo.png?v=20250902`} 
              alt="Prototype eSports Logo" 
              className="h-10 w-auto"
            />
            <span className="font-bold text-xl text-primary">Prototype eSports</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <React.Fragment key={item.name}>
                {item.type === 'scroll' && (
                  <button onClick={() => scrollToSection(item.href)} className="nav-link hover:text-primary transition-colors">{item.name}</button>
                )}
                {item.type === 'external' && (
                  <a href={item.href} target="_blank" rel="noopener noreferrer" className="nav-link hover:text-primary transition-colors">{item.name}</a>
                )}
              </React.Fragment>
            ))}
            <LanguageSwitcher className="ml-4" />
            <button 
              className="btn-primary ml-4"
              onClick={() => scrollToSection('#contact')}
            >
              {t('nav.joinSquad')}
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-primary hover:text-primary-hover transition-colors"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <React.Fragment key={item.name}>
                  {item.type === 'scroll' && (
                    <button onClick={() => scrollToSection(item.href)} className="nav-link text-left hover:text-primary transition-colors">{item.name}</button>
                  )}
                  {item.type === 'external' && (
                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="nav-link text-left hover:text-primary transition-colors">{item.name}</a>
                  )}
                </React.Fragment>
              ))}
              <div className="mt-4">
                <LanguageSwitcher />
              </div>
              <button 
                className="btn-primary mt-4"
                onClick={() => scrollToSection('#contact')}
              >
                {t('nav.joinSquad')}
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;